/* eslint-disable @typescript-eslint/camelcase */
import { commit, make } from "vuex-pathify";

const defaultState = () => {
  return {
    fields: []
  };
};

const state = defaultState();

const mutations = make.mutations(state);

const actions = {
  ...make.actions(state)
};

const getters = {
  ...make.getters(state)
};

export default {
  state,
  mutations,
  actions,
  getters
};
